import React, { useMemo } from 'react'

import { Outlet, Route, Routes } from 'react-router-dom'

import E404Index from '@/routes/_404/Index'

import { LoggedInRoute } from './LoggedInRoute'
import { LoggedOutRoute } from './LoggedOutRoute'

//	///////////////////////
//	MARK: EXPORTS
const SubRouterInternal: React.FC<{
  loggedIn?: boolean
  roles?: string[]
  ignoreSuperadmin?: boolean

  loggedOut?: boolean

  children?: React.ReactNode
}> = ({ loggedIn, roles, ignoreSuperadmin, loggedOut, children }) => {
  const content = useMemo(
    () => (
      <>
        <Routes>
          {children}
          <Route path='*' element={<E404Index />} />
        </Routes>
        <Outlet />
      </>
    ),
    [children],
  )

  if (loggedIn) {
    return (
      <LoggedInRoute roles={roles} ignoreSuperadmin={ignoreSuperadmin}>
        {content}
      </LoggedInRoute>
    )
  }

  if (loggedOut) {
    return <LoggedOutRoute>{content}</LoggedOutRoute>
  }

  return content
}

export const SubRouter = React.memo(SubRouterInternal) as typeof SubRouterInternal
